import { DatapointOptions, DatapointVariant } from 'owa-analytics-actions';
import { MillisecondsInOneDay } from 'mini-datetime-utils/lib/dateValues/constants';
import { trackWorkflow } from 'mini-app-context/lib/utils/workflowUtils';
import {
    ADD_CONTACT_SAVE_BUTTON_CLICKED,
    ADD_NEW_CONTACT_BUTTON_CLICKED,
    CANCEL_BUTTON_CLICKED,
    CONTACT_FORM_DISCARD_COMPLETE,
    DISCARD_BUTTON_CLICKED,
    EDIT_CONTACT_BUTTON_CLICKED,
    EDIT_CONTACT_SAVE_BUTTON_CLICKED,
    INTER_CARD_NAVIGATION_BEGIN,
    PEOPLE_CARD_COLD_LAUNCH_BEGIN,
    PEOPLE_CARD_LAUNCH_END,
    PEOPLE_CARD_WARM_LAUNCH_BEGIN,
    SAVE_CONTACT_COMPLETE,
} from './eventSignalConstants';

let isPeopleCardWorkflowAdded: boolean = false;

export const registerWorkflowsForPeopleCard = () => {
    if (isPeopleCardWorkflowAdded) {
        return;
    }

    const ADD_EDIT_CONTACT_COMMON_CHECKMARKS = [CANCEL_BUTTON_CLICKED, DISCARD_BUTTON_CLICKED];
    const ADD_EDIT_CONTACT_COMMON_END_SIGNALS = [
        SAVE_CONTACT_COMPLETE,
        CONTACT_FORM_DISCARD_COMPLETE,
    ];
    const commonOptions = { isCore: true };

    // Register the workflows needed for PeopleCard
    trackWorkflow<DatapointOptions>([
        {
            name: 'AddContact',
            start: ADD_NEW_CONTACT_BUTTON_CLICKED,
            checkmarks: [...ADD_EDIT_CONTACT_COMMON_CHECKMARKS, ADD_CONTACT_SAVE_BUTTON_CLICKED],
            end: ADD_EDIT_CONTACT_COMMON_END_SIGNALS,
            options: { ...commonOptions, timeout: MillisecondsInOneDay },
        },
        {
            name: 'EditContact',
            start: EDIT_CONTACT_BUTTON_CLICKED,
            checkmarks: [...ADD_EDIT_CONTACT_COMMON_CHECKMARKS, EDIT_CONTACT_SAVE_BUTTON_CLICKED],
            end: ADD_EDIT_CONTACT_COMMON_END_SIGNALS,
            options: { ...commonOptions, timeout: MillisecondsInOneDay },
        },
        {
            name: 'AddContactSave', // Atomic workflow which require no interaction from user after started, this DP is useful for alerting
            start: ADD_CONTACT_SAVE_BUTTON_CLICKED,
            end: [SAVE_CONTACT_COMPLETE],
            options: commonOptions,
        },
        {
            name: 'EditContactSave', // Atomic workflow
            start: EDIT_CONTACT_SAVE_BUTTON_CLICKED,
            end: [SAVE_CONTACT_COMPLETE],
            options: commonOptions,
        },
        {
            name: 'PeopleCardWarmStart',
            start: PEOPLE_CARD_WARM_LAUNCH_BEGIN,
            end: [PEOPLE_CARD_LAUNCH_END],
            options: { variant: DatapointVariant.ColdOnly, ...commonOptions },
        },
        {
            name: 'PeopleCardColdStart',
            start: PEOPLE_CARD_COLD_LAUNCH_BEGIN,
            end: [PEOPLE_CARD_LAUNCH_END],
            options: { variant: DatapointVariant.WarmOnly, ...commonOptions },
        },
        {
            name: 'InterCardNavigation',
            start: INTER_CARD_NAVIGATION_BEGIN,
            end: [PEOPLE_CARD_LAUNCH_END],
            options: commonOptions,
        },
    ]);

    isPeopleCardWorkflowAdded = true;
};
